import { createStart, createMiddleware } from "@tanstack/react-start";

import { renderErrorPage } from "./lib/error-page";
import { attachSupabaseAuth } from "@/integrations/supabase/auth-attacher";

const errorMiddleware = createMiddleware().server(async ({ next }) => {
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(error);
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

export const startInstance = createStart(() => ({
  functionMiddleware: [attachSupabaseAuth],
  // Intentionally no global Supabase auth middleware: this site has no
  // authenticated server functions, and importing it pulled the whole
  // supabase-js SDK into the initial client bundle (~100 kB gzip).
  // Re-add `attachSupabaseAuth` here if a protected serverFn is introduced.
  requestMiddleware: [errorMiddleware],
}));
